// A section declares its optional module in markup. Custom-element upgrades
// also run for sections inserted by the Theme Editor or Section Rendering API.
// Native module caching evaluates each dependency once per page.
if (!customElements.get('custom-section-assets')) {
  customElements.define('custom-section-assets', class extends HTMLElement {
    connectedCallback() {
      this.customCancelDeferred();
      if (!this.dataset.moduleUrl || this.customImport) return;
      const customPhone = window.matchMedia('(max-width: 699px)');
      const customSection = this.closest('.shopify-section');
      if (!this.hasAttribute('data-custom-mobile-defer') || !customPhone.matches ||
          window.Shopify?.designMode || !customSection || !('IntersectionObserver' in window)) {
        this.customLoad();
        return;
      }

      // Styles and HTML remain immediate. Enhance below-fold modules before
      // they enter view, without competing with the product gallery at startup.
      this.customAbort = new AbortController();
      const customOptions = { signal: this.customAbort.signal };
      this.customObserver = new IntersectionObserver(customEntries => {
        if (customEntries.some(customEntry => customEntry.isIntersecting)) this.customLoad();
      }, { rootMargin: '1000px 0px' });
      this.customObserver.observe(customSection);
      customSection.addEventListener('focusin', () => this.customLoad(), customOptions);
      customSection.addEventListener('pointerenter', () => this.customLoad(), customOptions);
      customPhone.addEventListener('change', customEvent => {
        if (!customEvent.matches) this.customLoad();
      }, customOptions);
    }

    disconnectedCallback() {
      this.customCancelDeferred();
    }

    customCancelDeferred() {
      this.customObserver?.disconnect();
      this.customAbort?.abort();
    }

    customLoad() {
      if (!this.isConnected || this.customImport) return;
      this.customCancelDeferred();
      const customModuleUrl = this.dataset.moduleUrl;
      this.customImport = import(customModuleUrl).catch(customError => {
        this.customImport = null;
        console.error('Unable to load custom section dependency:', customModuleUrl, customError);
      });
    }
  });
}
